/* tslint:disable */
/* eslint-disable */
/**
 * Reckon Bolt API
 * Backend API for Reckon Bolt
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
    import type {
        AgentVariableDistribution200ResponseInner,
        PatchedSoloQAccounts,
        SoloQAccounts,
        SoloQAccountsAggregate,
    } from '../models/index';

            export interface SoloQAccountsAggregateRequest {
                groupby: Array<string>;
                ordering: Array<string>;
                additional_filters?: object;
                aggregates?: Array<string>;
                having?: object;
                index_on?: string;
                last_updated?: string;
                metrics?: Array<string>;
                player?: string;
                puuid?: string;
            }

            export interface SoloQAccountsCreateRequest {
                id: string;
                solo_q_accounts: SoloQAccounts;
            }

            export interface SoloQAccountsFieldValuesRequest {
                field: string;
                ordering: Array<string>;
                additional_filters?: object;
                last_updated?: string;
                player?: string;
                puuid?: string;
            }

            export interface SoloQAccountsGetRequest {
                id: string;
            }

            export interface SoloQAccountsListRequest {
                additional_filters?: object;
                annotations?: Array<string>;
                last_updated?: string;
                only_values?: Array<string>;
                ordering?: Array<string>;
                player?: string;
                puuid?: string;
            }

            export interface SoloQAccountsPatchRequest {
                id: string;
                patched_solo_q_accounts?: PatchedSoloQAccounts;
            }

            export interface SoloQAccountsVariableDistributionRequest {
                bucket_size: number;
                max: number;
                metric: string;
                min: number;
                additional_filters?: object;
                last_updated?: string;
                player?: string;
                puuid?: string;
            }

        /**
        * 
        */
            export class SoloQAccountsApi extends runtime.BaseAPI {

            /**
            */
            async soloQAccountsAggregateRaw(requestParameters: SoloQAccountsAggregateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SoloQAccountsAggregate>>> {
                    if (requestParameters.groupby === null || requestParameters.groupby === undefined) {
                    throw new runtime.RequiredError('groupby','Required parameter requestParameters.groupby was null or undefined when calling soloQAccountsAggregate.');
                    }

                    if (requestParameters.ordering === null || requestParameters.ordering === undefined) {
                    throw new runtime.RequiredError('ordering','Required parameter requestParameters.ordering was null or undefined when calling soloQAccountsAggregate.');
                    }

            const queryParameters: any = {};

                    if (requestParameters.additional_filters !== undefined) {
                            queryParameters['additional_filters'] = requestParameters.additional_filters;
                    }

                    if (requestParameters.aggregates) {
                        queryParameters['aggregates'] = requestParameters.aggregates;
                    }

                    if (requestParameters.groupby) {
                        queryParameters['groupby'] = requestParameters.groupby;
                    }

                    if (requestParameters.having !== undefined) {
                            queryParameters['having'] = requestParameters.having;
                    }

                    if (requestParameters.index_on !== undefined) {
                            queryParameters['index_on'] = requestParameters.index_on;
                    }

                    if (requestParameters.last_updated !== undefined) {
                            queryParameters['last_updated'] = requestParameters.last_updated;
                    }

                    if (requestParameters.metrics) {
                        queryParameters['metrics'] = requestParameters.metrics;
                    }

                    if (requestParameters.ordering) {
                        queryParameters['ordering'] = requestParameters.ordering;
                    }

                    if (requestParameters.player !== undefined) {
                            queryParameters['player'] = requestParameters.player;
                    }

                    if (requestParameters.puuid !== undefined) {
                            queryParameters['puuid'] = requestParameters.puuid;
                    }

            const headerParameters: runtime.HTTPHeaders = {};

                        if (this.configuration && this.configuration.apiKey) {
                        headerParameters["Authorization"] = <string>this.configuration.apiKey("Authorization"); // tokenAuth authentication
                        }

            const response = await this.request({
            path: `/SoloQAccounts/operations/aggregate`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
            }, initOverrides);

                            return new runtime.JSONApiResponse(response);
            }

            /**
            */
                async aggregate(requestParameters: SoloQAccountsAggregateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SoloQAccountsAggregate>> {
                    const response = await this.soloQAccountsAggregateRaw(requestParameters, initOverrides);
                    return await response.value();
                }

            /**
            */
            async soloQAccountsCreateRaw(requestParameters: SoloQAccountsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SoloQAccounts>> {
                    if (requestParameters.id === null || requestParameters.id === undefined) {
                    throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling soloQAccountsCreate.');
                    }

                    if (requestParameters.solo_q_accounts === null || requestParameters.solo_q_accounts === undefined) {
                    throw new runtime.RequiredError('solo_q_accounts','Required parameter requestParameters.solo_q_accounts was null or undefined when calling soloQAccountsCreate.');
                    }

            const queryParameters: any = {};

            const headerParameters: runtime.HTTPHeaders = {};

                    headerParameters['Content-Type'] = 'application/json';

                        if (this.configuration && this.configuration.apiKey) {
                        headerParameters["Authorization"] = <string>this.configuration.apiKey("Authorization"); // tokenAuth authentication
                        }

            const response = await this.request({
            path: `/SoloQAccounts/item/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
                                body: requestParameters.solo_q_accounts,
            }, initOverrides);

                                return new runtime.JSONApiResponse(response);
            }

            /**
            */
                async create(requestParameters: SoloQAccountsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SoloQAccounts> {
                    const response = await this.soloQAccountsCreateRaw(requestParameters, initOverrides);
                    return await response.value();
                }

            /**
            */
            async soloQAccountsFieldValuesRaw(requestParameters: SoloQAccountsFieldValuesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
                    if (requestParameters.field === null || requestParameters.field === undefined) {
                    throw new runtime.RequiredError('field','Required parameter requestParameters.field was null or undefined when calling soloQAccountsFieldValues.');
                    }

                    if (requestParameters.ordering === null || requestParameters.ordering === undefined) {
                    throw new runtime.RequiredError('ordering','Required parameter requestParameters.ordering was null or undefined when calling soloQAccountsFieldValues.');
                    }

            const queryParameters: any = {};

                    if (requestParameters.additional_filters !== undefined) {
                            queryParameters['additional_filters'] = requestParameters.additional_filters;
                    }

                    if (requestParameters.field !== undefined) {
                            queryParameters['field'] = requestParameters.field;
                    }

                    if (requestParameters.last_updated !== undefined) {
                            queryParameters['last_updated'] = requestParameters.last_updated;
                    }

                    if (requestParameters.ordering) {
                        queryParameters['ordering'] = requestParameters.ordering;
                    }

                    if (requestParameters.player !== undefined) {
                            queryParameters['player'] = requestParameters.player;
                    }

                    if (requestParameters.puuid !== undefined) {
                            queryParameters['puuid'] = requestParameters.puuid;
                    }

            const headerParameters: runtime.HTTPHeaders = {};

                        if (this.configuration && this.configuration.apiKey) {
                        headerParameters["Authorization"] = <string>this.configuration.apiKey("Authorization"); // tokenAuth authentication
                        }

            const response = await this.request({
            path: `/SoloQAccounts/operations/field-values`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
            }, initOverrides);

                            return new runtime.JSONApiResponse<any>(response);
            }

            /**
            */
                async field_values(requestParameters: SoloQAccountsFieldValuesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
                    const response = await this.soloQAccountsFieldValuesRaw(requestParameters, initOverrides);
                    return await response.value();
                }

            /**
            */
            async soloQAccountsGetRaw(requestParameters: SoloQAccountsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SoloQAccounts>> {
                    if (requestParameters.id === null || requestParameters.id === undefined) {
                    throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling soloQAccountsGet.');
                    }

            const queryParameters: any = {};

            const headerParameters: runtime.HTTPHeaders = {};

                        if (this.configuration && this.configuration.apiKey) {
                        headerParameters["Authorization"] = <string>this.configuration.apiKey("Authorization"); // tokenAuth authentication
                        }

            const response = await this.request({
            path: `/SoloQAccounts/item/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
            }, initOverrides);

                                return new runtime.JSONApiResponse(response);
            }

            /**
            */
                async get(requestParameters: SoloQAccountsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SoloQAccounts> {
                    const response = await this.soloQAccountsGetRaw(requestParameters, initOverrides);
                    return await response.value();
                }

            /**
            */
            async soloQAccountsListRaw(requestParameters: SoloQAccountsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SoloQAccounts>>> {
            const queryParameters: any = {};

                    if (requestParameters.additional_filters !== undefined) {
                            queryParameters['additional_filters'] = requestParameters.additional_filters;
                    }

                    if (requestParameters.annotations) {
                        queryParameters['annotations'] = requestParameters.annotations;
                    }

                    if (requestParameters.last_updated !== undefined) {
                            queryParameters['last_updated'] = requestParameters.last_updated;
                    }

                    if (requestParameters.only_values) {
                        queryParameters['only_values'] = requestParameters.only_values;
                    }

                    if (requestParameters.ordering) {
                        queryParameters['ordering'] = requestParameters.ordering;
                    }

                    if (requestParameters.player !== undefined) {
                            queryParameters['player'] = requestParameters.player;
                    }

                    if (requestParameters.puuid !== undefined) {
                            queryParameters['puuid'] = requestParameters.puuid;
                    }

            const headerParameters: runtime.HTTPHeaders = {};

                        if (this.configuration && this.configuration.apiKey) {
                        headerParameters["Authorization"] = <string>this.configuration.apiKey("Authorization"); // tokenAuth authentication
                        }

            const response = await this.request({
            path: `/SoloQAccounts/list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
            }, initOverrides);

                            return new runtime.JSONApiResponse(response);
            }

            /**
            */
                async list(requestParameters: SoloQAccountsListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SoloQAccounts>> {
                    const response = await this.soloQAccountsListRaw(requestParameters, initOverrides);
                    return await response.value();
                }

            /**
            */
            async soloQAccountsPatchRaw(requestParameters: SoloQAccountsPatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SoloQAccounts>> {
                    if (requestParameters.id === null || requestParameters.id === undefined) {
                    throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling soloQAccountsPatch.');
                    }

            const queryParameters: any = {};

            const headerParameters: runtime.HTTPHeaders = {};

                    headerParameters['Content-Type'] = 'application/json';

                        if (this.configuration && this.configuration.apiKey) {
                        headerParameters["Authorization"] = <string>this.configuration.apiKey("Authorization"); // tokenAuth authentication
                        }

            const response = await this.request({
            path: `/SoloQAccounts/item/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
                                body: requestParameters.patched_solo_q_accounts,
            }, initOverrides);

                                return new runtime.JSONApiResponse(response);
            }

            /**
            */
                async patch(requestParameters: SoloQAccountsPatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SoloQAccounts> {
                    const response = await this.soloQAccountsPatchRaw(requestParameters, initOverrides);
                    return await response.value();
                }

            /**
            */
            async soloQAccountsVariableDistributionRaw(requestParameters: SoloQAccountsVariableDistributionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AgentVariableDistribution200ResponseInner>>> {
                    if (requestParameters.bucket_size === null || requestParameters.bucket_size === undefined) {
                    throw new runtime.RequiredError('bucket_size','Required parameter requestParameters.bucket_size was null or undefined when calling soloQAccountsVariableDistribution.');
                    }

                    if (requestParameters.max === null || requestParameters.max === undefined) {
                    throw new runtime.RequiredError('max','Required parameter requestParameters.max was null or undefined when calling soloQAccountsVariableDistribution.');
                    }

                    if (requestParameters.metric === null || requestParameters.metric === undefined) {
                    throw new runtime.RequiredError('metric','Required parameter requestParameters.metric was null or undefined when calling soloQAccountsVariableDistribution.');
                    }

                    if (requestParameters.min === null || requestParameters.min === undefined) {
                    throw new runtime.RequiredError('min','Required parameter requestParameters.min was null or undefined when calling soloQAccountsVariableDistribution.');
                    }

            const queryParameters: any = {};

                    if (requestParameters.additional_filters !== undefined) {
                            queryParameters['additional_filters'] = requestParameters.additional_filters;
                    }

                    if (requestParameters.bucket_size !== undefined) {
                            queryParameters['bucket_size'] = requestParameters.bucket_size;
                    }

                    if (requestParameters.last_updated !== undefined) {
                            queryParameters['last_updated'] = requestParameters.last_updated;
                    }

                    if (requestParameters.max !== undefined) {
                            queryParameters['max'] = requestParameters.max;
                    }

                    if (requestParameters.metric !== undefined) {
                            queryParameters['metric'] = requestParameters.metric;
                    }

                    if (requestParameters.min !== undefined) {
                            queryParameters['min'] = requestParameters.min;
                    }

                    if (requestParameters.player !== undefined) {
                            queryParameters['player'] = requestParameters.player;
                    }

                    if (requestParameters.puuid !== undefined) {
                            queryParameters['puuid'] = requestParameters.puuid;
                    }

            const headerParameters: runtime.HTTPHeaders = {};

                        if (this.configuration && this.configuration.apiKey) {
                        headerParameters["Authorization"] = <string>this.configuration.apiKey("Authorization"); // tokenAuth authentication
                        }

            const response = await this.request({
            path: `/SoloQAccounts/operations/variable-distribution`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
            }, initOverrides);

                            return new runtime.JSONApiResponse(response);
            }

            /**
            */
                async variable_distribution(requestParameters: SoloQAccountsVariableDistributionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AgentVariableDistribution200ResponseInner>> {
                    const response = await this.soloQAccountsVariableDistributionRaw(requestParameters, initOverrides);
                    return await response.value();
                }

        }
